import {captureException} from '@sentry/react';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {Nullish} from 'shared/web';

export const parseDeliveryNotePayload = (payloadString: string | Nullish): unknown => {
  if (!isNotNilOrEmpty(payloadString) || typeof payloadString !== 'string') {
    return null;
  }

  try {
    return JSON.parse(payloadString);
  } catch (error) {
    captureException(error, {
      extra: {
        rawPayload: payloadString,
        context: 'parseDeliveryNotePayload: Failed to parse JSON payload',
      },
    });
    return null;
  }
};
